/*
 * @Author: lyx
 * @Date: 2024-08-13 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-08-13 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P28/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";
import getGap from "../getGap";
import { toVisualThousands } from "../utils";
import { dropRight } from "lodash";
// import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";


const createLegend = (list = [],color = []) => {
  return {
    // data: list.map((item, index) => {
    //   return {
    //     name: item,
    //     itemStyle: {
    //       color: color[index],
    //     },
    //   };
    // }),
    show: true,
    bottom: 0,
    
  };
};
const createGraphic = (label = [], color = []) => {
  const children = [];
  label.forEach((ele, index) => {
    const left = index * 100;

    children.push({
      type: 'rect',
      z: 100,
      left: left,
      top: 'middle',
      shape: {
        width: 15,
        height: 10
      },
      style: {
        fill: color[index],
      }
    });
    children.push({
      type: 'text',
      z: 100,
      left: left + 20,
      top: 'middle',
      style: {
        fill: '#333',
        text: `${ele}`,
        font: '14px Microsoft YaHei'
      }
    });
  })

  return {
    type: 'group',
    bottom: -1,
    left: '3%',
    children,
  };
}

const createTitle = (list = []) => {
  const len = list.length;
  const _width = 100 / len;
  let arr = list.map((item, index) => {
    const left = `${index * _width}%`;
    const width = `20%`;
    return {
      text: item.name+'类内容条数',
      left: left,
      width: width,
      textAlign: 'left',
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#000",
      },
    };
  });
  return arr;
};
const createGrid = (list = []) => {
  const len = list.length;
  const offsetLeft = 5;
  const _width = 100 / len;

  return list.map((_, index) => {
    const left = `${index * _width + offsetLeft}%`;
    const width = `8%`;

    return {
      id: index,
      top: "10%",
      bottom: 20,
      left: index !== 0 ? left : '7%',
      width,
      containLabel: false
    };
  });
};
const createYAxis = (list = [], brandList = []) => {
  return list.map((item, index) => ({
    data: brandList,
    axisLabel:{
      show: true,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
        color: yAxisLabelColor,
      }
    }, 
    inverse: true,
    gridIndex: index,
    type: "category",
    
    axisTick: { show: false },
    axisLine: { show: true, lineStyle:{color: "#eee"} },
    minorTick: { show: false },
    splitLine: { show: false },
  }));
};

const createXAxis = (list = []) => {
  let arr = list.map((item, index) => ({
    type: "value",
    zeroAxisIndex: 0,

    gridIndex: index,
    axisLabel: {show: false},
    axisLine: { show: false },
    axisTick: { show: false },
    minorTick: { show: false },
    splitLine: { show: false },
  }));
  return arr;
};

const createSeries = (list = [], label = [], color = [], markPointData) => {
  var markPointData;

  let arr = list.map((item, index) => ({
    xAxisIndex: index,
    yAxisIndex: index,
    type: "bar",
    barWidth: "35%",
    label: {
      show: true,
      position: ['80%', '30%'],
      // position: "insideRight",
      // formatter: (ele) => toVisualThousands(ele.value),
      rich: {
        rankStyle: {
            color: 'red',
            fontSize: 12,
            padding: [3, 4, 0, 4], // 内边距，用于创建边框内的空间
              // 设置边框和宽高样式
            // padding: [5, 10],
            // lineHeight: 20,
            borderColor: 'red', // 边框颜色
            borderWidth: 1, // 边框宽度
            borderRadius: 30, // 边框圆角，设置为值的一半可以实现圆形效果（如果padding足够）
        }
      },
      formatter: function(ele) {
        var sortedData = item.list.slice().sort(function(a, b) {
          return b - a;
        });
        var top3 = sortedData.slice(0, 3);
        console.log(top3,"top3")
      
        // 配置markPoint，标记前三名
        markPointData = top3.map(function(item, index) {
            console.log(item)
            // var xIndex = item.findIndex(d => d === item.value);
            return {
                name: (index + 1) + '名: ' + item,
                // coord: [xIndex, item],
                value: item,
                itemStyle: {
                    color: 'red'
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: function() {
                        return (index + 1) + '名: ' + item;
                    }
                }
            };
        })
        if (top3.some(d => d === ele.value)) {
            let rank = top3.findIndex(d => d === ele.value) + 1;
            // return `{rankStyle|${rank}名}: ${params.value}`;
            return `${toVisualThousands(ele.value)}  {rankStyle|${rank}}` ;
        } else {
            return toVisualThousands(ele.value);
        }
      },
      markPoint: {
        data: markPointData,
        symbol: 'pin', // 标注的图形
        symbolSize: 60 // 标注的大小
      },
    },
    name: label[index],
    markPoint: markPointData,
    data: item.list.map((ele, _index) => {
      return {
      value: ele,
      itemStyle: {
        color: color[_index],
      },
    }}),
  }));
  return arr;
};

export default ({ chartList, brandList, color = [] }) => {
  // 获取为安踏品牌的index
  let redIndices = brandList.findIndex(item => item === "安踏");
  console.log(redIndices);
  // 遍历chartList数组，创建echarts柱状图配置项
  // chartList.forEach((item,index) => {
  //   // （最后一条数据是好感度，需要特殊处理，放到最前面）
  //   // 图表名称： item.name+'类内容条数'
  //   // 图标纵轴：brandList的数据
  //   // 图标数据：item.list的数据

  // });
  const list = dropRight(chartList);
  if (list.length == 0) return {};
  // 获取到中间数据，插入红色
  // const redIndex = Math.ceil(list[0].list.length / 2);
  // const newColor = color.filter(item => item !=='#ff0000');
  // newColor.splice(redIndex-1, 0, '#ff0000');
  // 专属品牌的index插入红色
  // const newColor = color.splice(redIndices, 0, '#ff0000');
  // console.log(newColor);

  

  return {
    title: createTitle(list),
    graphic: createGraphic(brandList, color),
    grid: createGrid(list),
    yAxis: createYAxis(list, brandList),
    xAxis: createXAxis(list),
    series: createSeries(list, brandList, color)
  };
};



// WEBPACK FOOTER //
// src/routes/visualChart/P29/chart.js